import React from 'react'
import logo from '../Images/logo-main-white.png'

function SimpleFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className='simpleFooter'>
      <div className='simpleFooterInner'>
        <div className='simpleFooterBrand'>
          <img src={logo} alt="Ubunifu College" className='simpleFooterLogo' />
          <p>Ubunifu Smart Campus</p>
        </div>
        <div className='simpleFooterLinks'>
          <a href='https://ubunifucollege.com/apply'>Apply</a>
          <a href='https://ubunifucollege.com/contact'>Contact</a>
        </div>
      </div>
      <div className='simpleFooterCopy'>
        © {currentYear} Ubunifu Group. All rights reserved.
      </div>
    </footer>
  )
}

export default SimpleFooter
